import { startCase } from "lodash";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import {
  formatValueDynamically,
  getFormattedValue,
} from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

type ParamValue = string | string[] | boolean;

interface MemberProfileCardProps {
  params: Record<string, ParamValue>;
  url: string;
}

export const MemberProfileCard = ({ params, url }: MemberProfileCardProps) => {
  const MEMBER_PROFILE_FIELDS = {
    name: {
      label: t("account.member_edit_profile_form.name"),
      type: "string",
    },
    member_tags: {
      label: t("account.member_edit_profile_form.member_tags_label"),
      type: "string",
    },
    admin: {
      label: t("account.member_edit_profile_form.admin"),
      type: "boolean",
    },
    is_flagged: {
      label: t("account.member_edit_profile_form.is_flagged"),
      type: "boolean",
    },
    messaging_disabled: {
      label: t("account.member_edit_profile_form.messaging_disabled"),
      type: "boolean",
    },
  };

  return (
    <PreviewCardLayout
      title={t("help_widget.copilot.preview_cards.member_profile_card_title")}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {/* rendering the member profile fields in particular order */}
        {Object.entries(MEMBER_PROFILE_FIELDS).map(
          ([key, keyProps]) =>
            params[key] && (
              <li key={key} className="!pb-0">
                <Typography.BodySm color="text-dark">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(params[key], keyProps.type)}
                </Typography.BodySm>
              </li>
            ),
        )}
        {/* rendering the other fields that are not in the MEMBER_PROFILE_FIELDS */}
        {Object.entries(params)
          .filter(([key]) => !(key in MEMBER_PROFILE_FIELDS))
          .map(([key, value]) => (
            <li key={key} className="!pb-0">
              <Typography.BodySm color="text-dark">
                <strong>{startCase(key)}:</strong>{" "}
                {formatValueDynamically(value)}
              </Typography.BodySm>
            </li>
          ))}
      </ul>
    </PreviewCardLayout>
  );
};
